/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Open360RetailerApiContractPhysicalProductBuyXGetYOfferValuesResourceModel } from './open360RetailerApiContractPhysicalProductBuyXGetYOfferValuesResourceModel';


export interface Open360RetailerApiContractPhysicalProductSpecialOfferResourceModel { 
    offerValidFrom?: Date;
    offerValidTo?: Date;
    /**
     * 0 = None, 1 = BuyXGetY, 2 = Discount
     */
    type?: Open360RetailerApiContractPhysicalProductSpecialOfferResourceModel.TypeEnum;
    buyXGetYOfferValues?: Open360RetailerApiContractPhysicalProductBuyXGetYOfferValuesResourceModel;
    discountPrice?: number;
}
export namespace Open360RetailerApiContractPhysicalProductSpecialOfferResourceModel {
    export type TypeEnum = 0 | 1 | 2;
    export const TypeEnum = {
        NUMBER_0: 0 as TypeEnum,
        NUMBER_1: 1 as TypeEnum,
        NUMBER_2: 2 as TypeEnum
    };
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360RetailerApiContractPhysicalProductSpecialOfferResourceModel.ts